import { useCallback } from 'react';
import { Box } from '@bridebook/ui';
import ClampedMessage from '@bridebook/web/app-basic/components/supplier/sections/reviews/clamped-message';
import StandardMessage from '@bridebook/web/app-basic/components/supplier/sections/reviews/standard-message';
import TrimmedMessage from '@bridebook/web/app-basic/components/supplier/sections/reviews/trimmed-message';
import type { IFeedbackSerialized } from '@bridebook/web/app-shared/lib/supplier/types';
import componentStyles from './message.style';

const CHAR_LIMIT = 100;

export interface IProps {
  trimText: boolean;
  isDesktop: boolean;
  isVenue: boolean;
  message: string;
  more: boolean;
  onReadMoreClick: (e: React.SyntheticEvent) => void;
  response?: IFeedbackSerialized['response'];
}

export interface IMessageSubcomponentProps extends Omit<IProps, 'isDesktop'> {
  limitText: (text: string) => string;
  showFullResponse: boolean;
}

const Message = ({
  message,
  more,
  onReadMoreClick,
  trimText,
  isDesktop,
  response,
  isVenue,
}: IProps) => {
  const showFullResponse = (response?.message.length || 0) > 0;
  const limitText = useCallback(
    (text: string): string =>
      text.length <= CHAR_LIMIT || more ? text : `${text.substring(0, CHAR_LIMIT)}...`,
    [more],
  );
  const styles = componentStyles();

  return (
    <Box style={styles.wrapper}>
      {trimText && (message.length > CHAR_LIMIT || (response?.message.length || 0) > CHAR_LIMIT) ? (
        <TrimmedMessage
          limitText={limitText}
          showFullResponse={showFullResponse}
          isVenue={isVenue}
          message={message}
          more={more}
          onReadMoreClick={onReadMoreClick}
        />
      ) : !isDesktop && !trimText ? (
        <ClampedMessage
          message={message}
          response={response}
          isVenue={isVenue}
          showFullResponse={showFullResponse}
        />
      ) : (
        <StandardMessage
          message={message}
          trimText={trimText}
          response={response}
          isVenue={isVenue}
          limitText={limitText}
          showFullResponse={showFullResponse}
        />
      )}
    </Box>
  );
};

export default Message;
